import {all, fork} from "redux-saga/effects"

import AuthSaga from "./auth/login/saga"
import LayoutSaga from "./layout/saga"
import layoutHeaderSaga from "./layout/header/saga"
import inboxSaga from "./inbox/saga";
import filesSaga from "./files/saga";
import slipSaga from "./slip/saga";
import invoiceSaga from "./invoice/saga";
import companiesSaga from "./companies/saga";
import analyticalAccountsSaga from "./companies/analyticalAccounts/saga";
import sectionsSaga from "./sections/saga";
import segmentsSaga from "./segments/saga";
import usersSaga from "./users/saga";
import userPermissionsSaga from "./users/permissions/saga";
import groupsSaga from "./groups/saga";
import groupPermissionsSaga from "./groups/permissions/saga";
import enumPermissionsSaga from "./enums/permissions/saga";
import enumVersionsSaga from "./enums/versions/saga";
import enumStoragesSaga from "./enums/storages/saga";
import selectModalSaga from "./components/selectModal/saga";
import smartDropzoneSaga from "./components/smartDropzone/saga";
import notificationsSaga from "./notifications/saga";
import confirmModalSaga from "./components/confirmModal/saga";
import searchSaga from "./search/saga";
import graphModalSaga from "./components/graphModal/saga";
import simpleFilesSaga from "./simpleFiles/saga";
import notificationDropdownSaga from "./layout/notificationDropdown/saga"
import userNotificationsModalSaga from "./userNotificationsModal/saga";
import dashboardSaga from "./dashboard/saga"

export default function* rootSaga() {
  yield all([
    fork(AuthSaga),
    fork(LayoutSaga),
    fork(layoutHeaderSaga),
    fork(inboxSaga),
    fork(filesSaga),
    fork(slipSaga),
    fork(invoiceSaga),
    fork(companiesSaga),
    fork(analyticalAccountsSaga),
    fork(sectionsSaga),
    fork(segmentsSaga),
    fork(usersSaga),
    fork(userPermissionsSaga),
    fork(groupsSaga),
    fork(groupPermissionsSaga),
    fork(enumPermissionsSaga),
    fork(enumVersionsSaga),
    fork(enumStoragesSaga),
    fork(selectModalSaga),
    fork(smartDropzoneSaga),
    fork(notificationsSaga),
    fork(confirmModalSaga),
    fork(searchSaga),
    fork(graphModalSaga),
    fork(simpleFilesSaga),
    fork(notificationDropdownSaga),
    fork(userNotificationsModalSaga),
    fork(dashboardSaga),
  ])
}
